import { useCallback } from "react";
import { DICTS } from "~/data/i18n";
import { useUiStore } from "~/stores/uiStore";

export const useT = () => {
  const lang = useUiStore((s) => s.lang);
  const setLang = useUiStore((s) => s.setLang);
  const t = useCallback(
    (k: string): string => DICTS[lang][k] ?? DICTS.en[k] ?? k,
    [lang],
  );
  return { t, lang, setLang };
};
